import {AbstractControl, ValidatorFn} from '@angular/forms';

export function nonZeroValidator(customParam?: string): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} | null => {
    const param = customParam ? customParam : 'nonZero';
    const value = control.value;

    if (value !== null && value !== undefined && value <= 0) {
      return {[param]: true};
    }

    return null;
  };
}
